import classNames from 'classnames';
import React from 'react';

import styles from './Link.module.scss';

interface LinkProps {
    href: string;
    children: React.ReactNode;
    className?: string;
    onClick?: (event: React.MouseEvent<HTMLAnchorElement>) => void;
}

export const Link = ({ href, children, className, onClick }: LinkProps) => {
    return (
        <a
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            className={classNames(styles.Link, className)}
            onClick={onClick}
        >
            {children}
        </a>
    );
};
